import { Button, Typography } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div<{ margin: boolean }>`
  margin-top: ${({ margin }) => (margin ? "25px" : "0")};
  form {
    background: ${({ theme }) => theme.palette.background.paper};
    // TODO => usar radios
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 16px;
    > span {
      padding: 24px 45px;
    }
  }
`;

// TODO => usar component typography
export const Title = styled.p`
  font-style: normal;
  font-weight: 400;
  width: 100%;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 24px 45px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: 100%;
  background: ${({ theme }) => theme.palette.background.default};
  div:last-child {
    box-shadow: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 68px;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
  justify-content: space-between;
`;

// TODO => usar component typography
export const CardName = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

// TODO => usar component typography
export const CardPrice = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Footer = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  button {
    &:hover {
      background: ${({ theme }) => theme.palette.action.hover};
      transition: 0.2s;
    }
    height: 30px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  > div {
    width: 120px;
    background: ${({ theme }) => theme.palette.background.paper};
  }
`;

export const TitleView = styled(Typography)<{ colorText: boolean }>`
  color: ${({ theme, colorText }) =>
    colorText ? theme.palette.primary.main : theme.palette.text.disabled};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ButttonAdd = styled(Button)<{ disabled: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.primary.main : theme.palette.text.disabled};
  border: ${({ disabled }) =>
    disabled
      ? `1px solid rgba(0, 0, 0, 0.12)`
      : `1px solid rgba(211, 49, 0, 0.5)`};
`;

export const DivContainerButton = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  > button {
    height: 42px !important;
    border-radius: 20px;
    height: 40px;
  }
`;
